import React, { useEffect, useState } from "react";
import Image from "../../../elements/Image";
import Select from "../../../form/Select";
import Radio from "../../../form/Radio";
import Input from "../../../form/Input";
import Button from "../../../form/Button";
import { classNames } from "../../../../helpers/classNames";
import { useSelector } from "react-redux";
import DatePicker from "../../../form/DatePicker";
import Tooltip from "../../../elements/Tooltip";

const TakeActionStepOne = ({
  data,
  setStep,
  stepOneFormData,
  setStepOneFormData = () => {},
}) => {
  const [donationType, setDonationType] = useState(null);
  const [customDonation, setCustomDonation] = useState(false);
  const [donationFrequency, setDonationFrequency] = useState("");
  const { siteSetting } = useSelector((state) => state.setting);
  const [donationAmount, setDonationAmount] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [errorMessages, setErrorMessages] = useState({
    donationAmount: "",
    donationType: "",
    donationFrequency: "",
  });

  const handleRadioChange = (e) => {
    setDonationAmount(e?.target?.value);
  };
  const handleDatePicker = (newDate) => {
    setDate(newDate);
  };

  useEffect(() => {
    if (donationAmount || customDonation) {
      setPaymentAmount(customDonation ? customDonation : donationAmount);
    }
  }, [donationAmount, customDonation]);

  useEffect(() => {
    if (paymentAmount) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        donationAmount: "",
      }));
    }
  }, [paymentAmount]);

  useEffect(() => {
    if (donationType) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        donationType: "",
      }));
    }
  }, [donationType]);

  useEffect(() => {
    if (donationFrequency) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        donationFrequency: "",
      }));
    }
  }, [donationFrequency]);
  useEffect(() => {
    if (organizationName) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        organizationName: "",
      }));
    }
  }, [organizationName]);
  useEffect(() => {
    if (stepOneFormData) {
      const predefinedValues = [10, 20, 50, 100];
      const savedAmount = Number(stepOneFormData?.donationAmount);

      const isPredefined = predefinedValues.includes(savedAmount);

      setDonationType(stepOneFormData?.donationType || null);
      setDonationFrequency(stepOneFormData?.donationFrequency || "");
      setOrganizationName(stepOneFormData?.organizationName || "");
      setPaymentAmount(savedAmount || "");

      if (isPredefined) {
        setDonationAmount(savedAmount.toString());
        setCustomDonation(false);
      } else {
        setDonationAmount("");
        setCustomDonation(savedAmount.toString());
      }
      if (stepOneFormData?.recurringActionDate) {
        const parsedDate = new Date(stepOneFormData.recurringActionDate);

        if (!isNaN(parsedDate.getTime())) {
          setDate({
            startDate: parsedDate,
            endDate: parsedDate,
          });
        }
      }
    }
  }, [stepOneFormData]);

  const validateForm = () => {
    let errors = {};

    if (!paymentAmount) {
      errors.donationAmount = "Please choose or enter an amount";
    }

    if (!donationType) {
      errors.donationType = "Please select a donation type";
    }

    if (!donationFrequency) {
      errors.donationFrequency = "Please select a donation frequency";
    }

    if (donationType === "organization" && !organizationName) {
      errors.organizationName = "Please enter organization name";
    }

    setErrorMessages(errors);

    return Object.keys(errors).length === 0;
  };

  const onSubmit = async () => {
    if (!validateForm()) return;

    setErrorMessages({
      donationAmount: "",
      donationType: "",
      donationFrequency: "",
      recurringDate: "",
    });

    setStepOneFormData({
      donationAmount: paymentAmount,
      donationType: donationType,
      donationFrequency: donationFrequency,
      organizationName: organizationName,
      recurringActionDate: date?.startDate?.toISOString() || null,
    });
    setStep(2);
  };

  const planList = [
    { price: "10", value: 10 },
    { price: "20", value: 20 },
    { price: "50", value: 50 },
    { price: "100", value: 100 },
  ];
  return (
    <>
      <div className="relative py-0 lg:py-10 space-y-6 md:space-y-10">
        <div className="space-y-3 md:space-y-6">
          <div className="w-28 mx-auto">
            {data?.details?.takeAction?.image?.url ? (
              <Image
                src={data?.details?.takeAction?.image?.url}
                alt={""}
                effect="blur"
                classes="object-contain object-left"
              />
            ) : (
              <div className="w-32 h-12 bg-gray-300 animate-pulse" />
            )}
          </div>
          <div className="text-xs sm:text-sm xls:text-base xl:text-lg font-Gotham xls:font-medium text-shades-05">
            Thanks for your contribution—every dollar counts.
          </div>
        </div>

        <div className="relative">
          <div className="relative mb-6">
            <Select
              label={"I am taking action as"}
              xPlacement={"bottomRight"}
              labelClasses={"mb-2 !text-gable-green font-medium !text-base"}
              dropdownButtonClass={"!h-14 !rounded-lg !text-base"}
              dropdownClass={""}
              optionsClass={"!text-base"}
              dropdownData={
                [
                  { name: "An Individual", value: "individual" },
                  { name: "An Organization", value: "organization" },
                ] || []
              }
              selectedValue={donationType}
              setSelectedValue={setDonationType}
              placeholder={"I am taking action as"}
            />
            {errorMessages?.donationType && (
              <div className="text-amber-600 text-xs font-medium">
                <i className="fa-regular fa-triangle-exclamation"></i>
                {errorMessages?.donationType}
              </div>
            )}
          </div>
          {donationType === "organization" && (
            <div className="relative mb-6">
              <Input
                label={"Organization name"}
                labelClasses={"mb-2 !text-gable-green !text-base"}
                inputClasses={
                  "!bg-shades-03 !border-0 rounded-lg !h-12 !text-base"
                }
                value={organizationName}
                inputPlaceholder={"Enter Organization name"}
                onChange={(e) => setOrganizationName(e.target.value)}
              />
              {errorMessages?.organizationName && (
                <div className="text-amber-600 text-xs font-medium">
                  <i className="fa-regular fa-triangle-exclamation"></i>
                  {errorMessages?.organizationName}
                </div>
              )}
            </div>
          )}
          <div
            className={classNames(
              "relative mb-6",
              customDonation ? "pointer-events-none opacity-50" : ""
            )}
          >
            <div className="mb-3 text-gable-green font-medium text-base">
              Choose Amount
            </div>
            <div className="flex items-center gap-5 md:gap-10 lg:gap-3 xls:gap-10">
              {planList?.map((item, index) => (
                <Radio
                  key={index}
                  radioLabel={`$${item?.price}`}
                  radioName={"donation_ammount"}
                  radioLableClass="font-CanelaDeck !text-gable-green font-medium !text-base !ml-1 md:!ml-3"
                  value={item?.price}
                  onChange={handleRadioChange}
                  isChecked={donationAmount === item.price}
                />
              ))}
            </div>
          </div>
          <div className="relative mb-6">
            <Button
              buttonHasLink={false}
              buttonFunction={() => setCustomDonation(!customDonation)}
              buttonLabel={"Enter Custom Amount"}
              buttonClasses={
                "!h-14 !bg-transparent !px-0 !text-chestnut-rose underline"
              }
            />
            {customDonation && (
              <Input
                label={"Donation amount"}
                inputType={"number"}
                labelClasses={"mb-2 !text-gable-green !text-base"}
                inputClasses={
                  "!bg-shades-03 !border-0 rounded-lg !h-12 !text-base"
                }
                inputPlaceholder={"Enter donation amount"}
                value={customDonation}
                onChange={(e) => setCustomDonation(e.target.value)}
              />
            )}
          </div>
          {errorMessages?.donationAmount && (
            <div className="text-amber-600 text-xs font-medium">
              <i className="fa-regular fa-triangle-exclamation"></i>
              {errorMessages?.donationAmount}
            </div>
          )}
          <div className="relative">
            <div className="relative mb-2">
              <Select
                label={"Choose Frequency"}
                xPlacement={"bottomRight"}
                labelClasses={"mb-2 !text-gable-green font-medium !text-base"}
                dropdownButtonClass={"!h-14 !rounded-lg !text-base"}
                dropdownClass={""}
                optionsClass={"!text-base"}
                dropdownData={
                  [
                    { name: "Monthly", value: "monthly" },
                    { name: "One time", value: "oneTime" },
                  ] || []
                }
                selectedValue={donationFrequency}
                setSelectedValue={setDonationFrequency}
                placeholder={"Choose Donation Frequency"}
              />
            </div>
            {errorMessages?.donationFrequency && (
              <div className="text-amber-600 text-xs font-medium">
                <i className="fa-regular fa-triangle-exclamation"></i>
                {errorMessages?.donationFrequency}
              </div>
            )}
          </div>
          {donationFrequency === "monthly" && (
            <div className="grid grid-cols-1 gap-4 mb-6">
              <div className="col-span-1">
                <DatePicker
                  label={
                    <div className="flex items-center gap-2">
                      <span className="!text-gable-green !font-medium !text-base">
                        Recurring Action Date
                      </span>
                      <Tooltip
                        position="top"
                        messageClass="max-w-52"
                        message="Choose the day each month for your recurring action."
                      >
                        <i className="fa-fw fa-regular fa-info-circle text-chestnut-rose text-xs cursor-pointer"></i>
                      </Tooltip>
                    </div>
                  }
                  labelClasses="!mb-2"
                  value={date}
                  onChange={handleDatePicker}
                  dateFormat="DD/MM/YYYY"
                  minDate={
                    new Date(new Date().setDate(new Date().getDate() + 1))
                  }
                  asSingle={true}
                  renge={false}
                  className={"rt-datepicker"}
                />
              </div>
            </div>
          )}

          <div className="relative flex justify-center">
            <Button
              buttonLabel={"Take Action"}
              buttonClasses={"!h-10 xls:!h-12 !rounded-full !px-6 xls:!px-10"}
              buttonFunction={onSubmit}
              buttonLabelClasses={"text-base xls:!text-lg"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TakeActionStepOne;
